export default {
  // SSL 보안서버 상태
  UNINSTALLED: '미설치',
  WAITING: '설치중',
  INSTALLED: '설치완료',
  EXPIRATION: '기간만료',
  WAITING_EXTENSION: '설치중(연장)',
};
